import { createSlice } from '@reduxjs/toolkit';

// Load cart from localStorage
const loadCartFromStorage = () => {
  try {
    const cartData = localStorage.getItem('cart');
    return cartData ? JSON.parse(cartData) : [];
  } catch (error) {
    console.error('Error loading cart from storage:', error);
    return [];
  }
};

// Save cart to localStorage
const saveCartToStorage = (cart) => {
  try {
    localStorage.setItem('cart', JSON.stringify(cart));
  } catch (error) {
    console.error('Error saving cart to storage:', error);
  }
};

const initialState = {
  items: loadCartFromStorage(),
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { product, quantity = 1 } = action.payload;
      
      // For products with sizes, create unique identifier
      const itemId = product.sizeId ? `${product.id}-${product.sizeId}` : product.id;
      const existingItem = state.items.find(item => {
        const existingItemId = item.sizeId ? `${item.id}-${item.sizeId}` : item.id;
        return existingItemId === itemId;
      });

      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        state.items.push({
          ...product,
          quantity,
        });
      }

      saveCartToStorage(state.items);
    },
    removeFromCart: (state, action) => {
      const itemId = action.payload;
      state.items = state.items.filter(item => {
        const currentItemId = item.sizeId ? `${item.id}-${item.sizeId}` : item.id;
        return currentItemId !== itemId;
      });
      saveCartToStorage(state.items);
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const item = state.items.find(item => {
        const currentItemId = item.sizeId ? `${item.id}-${item.sizeId}` : item.id;
        return currentItemId === id;
      });
      
      if (item) {
        if (quantity <= 0) {
          state.items = state.items.filter(item => {
            const currentItemId = item.sizeId ? `${item.id}-${item.sizeId}` : item.id;
            return currentItemId !== id;
          });
        } else {
          item.quantity = quantity;
        }
      }

      saveCartToStorage(state.items);
    },
    clearCart: (state) => {
      state.items = [];
      saveCartToStorage(state.items);
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;

// Selectors
export const selectCartItems = (state) => state.cart.items;
export const selectCartTotal = (state) => {
  return state.cart.items.reduce((total, item) => {
    // Assuming each product has a price property
    const price = item.price || 0;
    return total + (price * item.quantity);
  }, 0);
};
export const selectCartItemsCount = (state) => {
  return state.cart.items.reduce((count, item) => count + item.quantity, 0);
};

export default cartSlice.reducer;
